import React, { useState, useCallback, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import StyledCheckbox from 'Shared/components/Checkboxes/StyledCheckbox/StyledCheckbox';
import { groupTimelineFilterValues } from 'Shared/selectors/workspace';

import CompletedTopicsAndItemsList from './CompletedTopicsAndItemsList/CompletedTopicsAndItemsList';
import TimelineViewSection from './TimelineViewSection/TimelineViewSection';
import WorkspaceTabHeader from '../../../../partials/WorkspaceTabHeader';

type Props = {
  focusedItemUuid: string;
};

function CompletedSection({ focusedItemUuid }: Props) {
  const dispatch = useDispatch();
  const [showGroupByWeek, setShowGroupByWeek] = useState(true);

  useEffect(() => {
    return () => dispatch({ type: 'CLEAR_COMPLETED_ITEMS' });
  }, []);

  const showGroupByWeekToggle = useCallback(() => setShowGroupByWeek(state => !state), []);

  return (
    <div className="d-flex flex-column w-100 mb-2">
      <WorkspaceTabHeader title="Completed Items" />
      <StyledCheckbox
        id="emailNotification"
        name="emailNotification"
        className="mb-2"
        label="Group by week completed"
        checked={showGroupByWeek}
        onChange={showGroupByWeekToggle}
      />
      {!showGroupByWeek ? (
        <CompletedTopicsAndItemsList focusedItemUuid={focusedItemUuid} />
      ) : (
        <TimelineViewSection groupTimelineFilterValue={groupTimelineFilterValues.COMPLETED_AT} />
      )}
    </div>
  );
}

export default memo(CompletedSection);
